document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('[data-toggle="tab"]');
  if (!tabs.length) return;

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').replace('#', '');
      const target = document.getElementById(targetId);
      if (!target) return;

      document.querySelectorAll('.tab-pane[id^="zona-"]').forEach(function(pane) {
        pane.classList.remove('in', 'active', 'show');
      });
      target.classList.add('in', 'active', 'show');

      tabs.forEach(function(t) { t.classList.remove('active', 'show'); });
      this.classList.add('active', 'show');
    });
  });
});
